import type { ComponentType } from 'react';

import {
  createSearchFlowRoutes,
  loadLandingForgotPasswordRoute,
  loadLandingLoginRoute,
  loadLandingRegisterRoute,
} from '../shared/search-flow-routes';

const cheatingPartnerBasePaths = [
  '/catch-cheating-partner-xx',
  '/catch-cheating-partner-xy',
] as const;

const loadWomanLanding = async (): Promise<{ Component: ComponentType }> => {
  const { CheatingPartnerWomanLandingRoute } =
    await import('./LandingRoute/LandingRoute');
  return { Component: CheatingPartnerWomanLandingRoute };
};

const loadManLanding = async (): Promise<{ Component: ComponentType }> => {
  const { CheatingPartnerManLandingRoute } =
    await import('./LandingRoute/LandingRoute');
  return { Component: CheatingPartnerManLandingRoute };
};

const loadSearchRoute = async (): Promise<{ Component: ComponentType }> => {
  const { LoginRoute } = await import('./LoginRoute/LoginRoute');
  return { Component: LoginRoute };
};

const createRoutesForPath = (
  basePath: (typeof cheatingPartnerBasePaths)[number],
): ReturnType<typeof createSearchFlowRoutes> =>
  createSearchFlowRoutes({
    basePath,
    landingLoader: basePath.endsWith('-xx') ? loadWomanLanding : loadManLanding,
    searchLoader: loadSearchRoute,
    loginLoader: loadLandingLoginRoute,
    registerLoader: loadLandingRegisterRoute,
    forgotPasswordLoader: loadLandingForgotPasswordRoute,
  });

export const catchCheatingPartnerRoutes = cheatingPartnerBasePaths.flatMap(
  (basePath) => createRoutesForPath(basePath).publicRoutes,
);

export const protectedCatchCheatingPartnerRoutes =
  cheatingPartnerBasePaths.flatMap(
    (basePath) => createRoutesForPath(basePath).protectedRoutes,
  );
